<template>
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
  >
    <path
      d="M13 3.66663L12.5869 10.35C12.4813 12.0576 12.4285 12.9114 12.0005 13.5252C11.7889 13.8287 11.5165 14.0848 11.2005 14.2773C10.5614 14.6666 9.706 14.6666 7.99513 14.6666C6.28208 14.6666 5.42553 14.6666 4.78603 14.2766C4.46987 14.0838 4.19733 13.8272 3.98579 13.5232C3.55792 12.9084 3.5063 12.0534 3.40307 10.3434L3 3.66663"
      stroke="#667085"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path d="M14 3.66663H2" stroke="#667085" stroke-width="1.5" stroke-linecap="round" />
    <path
      d="M10.705 3.66671L10.2499 2.72786C9.94753 2.10421 9.7964 1.79239 9.53567 1.59791C9.4778 1.55477 9.4166 1.5164 9.35253 1.48317C9.0638 1.33337 8.71727 1.33337 8.0242 1.33337C7.31373 1.33337 6.95847 1.33337 6.66497 1.48945C6.59991 1.52405 6.53783 1.56397 6.47937 1.60882C6.2156 1.81117 6.06826 2.13441 5.77358 2.78088L5.36979 3.66671"
      stroke="#667085"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path d="M6.33333 11V7" stroke="#667085" stroke-width="1.5" stroke-linecap="round" />
    <path d="M9.66667 11V7" stroke="#667085" stroke-width="1.5" stroke-linecap="round" />
  </svg>
</template>

<script>
// TODO: This icon is not used anywhere
export default {
  props: {
    height: {
      type: String,
      default: '16',
    },
    width: {
      type: String,
      default: '16',
    },
  },
}
</script>
